import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const UnexpectedError: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={1.17777 * size}
      viewBox="0 0 90 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43 63V29h4v34h-4zM45 77a4 4 0 100-8 4 4 0 000 8z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45 .687l45 26.162v52.302l-45 26.162L0 79.151V26.849L45 .687zM4 29.15v47.698l41 23.838 41-23.838V29.151L45 5.313 4 29.151z"
        fill={color}
      />
    </svg>
  );
};

export default UnexpectedError;
